import CampaignsList from "../../components/Campaigns/CampaignsList";

const campaignsRoutes = [
    { path: '', name: 'campaignsList', component: CampaignsList,
    },
];

export default campaignsRoutes;
